import Button from '@mui/material/Button';
import Fab from '@mui/material/Fab';
import { Plus } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import useIsMobileShell from '../../hooks/useIsMobileShell';
import { isBottomNavVisible } from '../layout/bottomNavPaths';

// Botão de "novo registro" das listagens. Desktop/tablet: o mesmo botão
// `contained` com ícone "+" de sempre. Shell mobile: FAB azul fixo no canto
// inferior direito, acima da barra de navegação (igual ao
// `FloatingActionButton` das telas de lista do `fv-app`).
const MOBILE_ACCENT = '#448AFF';
const BOTTOM_NAV_HEIGHT = 64;

export default function NewItemButton({ label, onClick }) {
    const isMobileShell = useIsMobileShell();
    const { pathname } = useLocation();

    if (!isMobileShell) {
        return (
            <Button
                variant="contained"
                startIcon={<Plus size={16} strokeWidth={2.5} />}
                onClick={onClick}
            >
                {label}
            </Button>
        );
    }

    return (
        <Fab
            aria-label={label}
            onClick={onClick}
            sx={{
                position: 'fixed',
                right: 'calc(16px + env(safe-area-inset-right, 0px))',
                bottom: isBottomNavVisible(pathname)
                    ? `calc(${BOTTOM_NAV_HEIGHT}px + 16px + env(safe-area-inset-bottom, 0px))`
                    : 'calc(16px + env(safe-area-inset-bottom, 0px))',
                zIndex: (t) => t.zIndex.appBar - 1,
                color: '#fff',
                backgroundColor: MOBILE_ACCENT,
                '&:hover': { backgroundColor: MOBILE_ACCENT }
            }}
        >
            <Plus size={24} strokeWidth={2.5} />
        </Fab>
    );
}
